import { render } from "./Waitchat.vue?vue&type=template&id=3f28ca00"
import script from "./Waitchat.vue?vue&type=script&lang=js"
export * from "./Waitchat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__